export default {
  web: {
    common: {
      for: "para",
      today: "Hoy",
      unknown: "Desconocido",
      checkout: "Pagar",
      noOdds: "Sin cuotas",
    },
    navigation: {
      tools: "Herramientas",
      getLinematePlus: "Obtén Linemate+",
      startFreeTrial: "Comenzar prueba gratis",
      downloadLinemate: "Descargar Linemate",
      profileSettings: "Configuración del perfil",
      closeMyPicks: "Cerrar Mis Picks",
      offSeason: "{{league}} está fuera de temporada. Nos vemos la próxima temporada.",
      search: {
        teams: "Equipos",
        noResultsFor: "No se encontraron resultados para \"{{searchTerm}}\"",
      },
      toolsMenu: {
        opponentDefensiveRank: "Ranking defensivo del rival",
        startingOpponentPitchers: "Lanzadores abridores rivales",
      },
    },
    toastModal: {
      title: "¿Qué hay de nuevo?",
      items: {
        checkout: "Haz checkout en tu casa de apuestas preferida con Mis Picks.",
        preferredOdds: "Ve las cuotas de tendencias con tus cuotas preferidas (disponible para usuarios de Linemate+).",
      },
      actions: {
        dismiss: "Cerrar",
      },
    },
    carousel: {
      previous: "Anterior",
      next: "Siguiente",
    },
  },
};
